import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';

// Vite emits this event when a cached app shell references a chunk that no
// longer exists after a deployment. Reload once so the browser fetches the
// current HTML and its matching hashed assets instead of leaving a blank app.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

/**
 * QueryClient setup.
 *
 * Defaults are tuned for typical SPA use:
 *  - 1 minute stale time so quick navigations don't refetch
 *  - retry once on failure (more = annoying when offline)
 *  - refetchOnWindowFocus is on by default — keep it
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
